<template>
  <div class="content">
    <center-nav></center-nav>
    <slider-menu :menuData="menuData"></slider-menu>
  </div>
</template>

<script>
import centerNav from "@/components/centerNav";
import sliderMenu from "@/components/SliderMenu";

export default {
  components: {
    centerNav, // 头部导航
    sliderMenu, // 侧边栏
  },
  data() {
    return {
      menuData: [
        {
          path: "/pc/promotion/home",
          icon: "icon-api_refresh_home_n_1",
          title: "主页",
          hidden: false,
          iconSize: '16px'
        },
        {
          path: "/pc/promotion/manage",
          icon: "icon-api_refresh_tgwzgl_n_2",
          title: "推广位管理",
          hidden: false,
          iconSize: '16px'
        },
        {
          path: "/pc/promotion/report",
          icon: "icon-api_refresh_apidd_n_4",
          title: "推广位报表",
          hidden: false,
          iconSize: '16px'
        },
        {
          path: "/pc/promotion/order",
          icon: "icon-api_refresh_tgwbb_n_3",
          title: "API订单",
          hidden: false,
          iconSize: '16px'
        },
        {
          path: "/pc/promotion/taobaoOrderError",
          icon: "icon-api_refresh_tgwbb_n_3",
          title: "淘宝询价人工纠错",
          hidden: false,
          iconSize: '16px'
        },
        {
          path: "/pc/promotion/money",
          icon: "icon-api_refresh_zjmx_n_5",
          title: "资金明细",
          hidden: false,
          iconSize: '16px'
        },
        // {
        //   path: "/pc/promotion/invoice",
        //   icon: "icon-api_refresh_zjmx_n_5",
        //   title: "我的发票",
        //   hidden: false,
        //   iconSize: '16px'
        // },
        {
          path: "/pc/promotion/setting",
          icon: "icon-api_refresh_grsz_n_6",
          title: "个人设置",
          hidden: false,
          iconSize: '16px'
        },
      ]
    }
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/pc/promotion/Index.vue